<template>
	<div style="position: fixed; left: 100%; top: 0;">
		<input ref="file" type="file" :accept="accept" :multiple="multiple" @change="uploadHandle" />
	</div>
</template>

<script>
	import ossUpload from '@/submodule/assets/script/lib/oss/upload'
	
	export default {
		name: 'upload',
		
		data() {
			return {
				type: '',
				multiple: false
			}
		},
		
		computed: {
			accept() {
				if (this.type) {
					let arr = [];
					this.type.split(',').forEach(item => {
						arr = arr.concat({
							image: ['.jpg', '.jpeg', '.png'],
							video: ['.mp4'],
							word: ['.doc', '.docx'],
							excel: ['.xls', '.xlsx'],
							zip: ['.zip', '.7z', '.rar']
						}[item] || ['.' + item])
					});
					return arr.join(',');
				}
				return '';
			}
		},
		
		methods: {
			main(opt = {}) {
				this.type = opt.type;
				this.multiple = !!opt.multiple;
				this._opt = opt;
				this.$nextTick(() => {
					this.$refs.file.click();
				});
			},
			
			uploadHandle(e) {
				let files = e.target.files;
				if (this._opt.type || this._opt.size) {
					for (let i = 0; i < files.length; i++) {
						let file = files[i];
						
						if (this._opt.type) {
							var typeList = this.accept.split(',');
							var type = file.name.match(/\.[^\.]+$/)[0];
							if (!typeList.includes(type)) {
								this.$message({
									message: this.$t('_t.upload.message.type', {type: typeList.join('、')})
								})
								this.$refs.file.value = '';
								return;
							}
						}
					
						if (this._opt.size && file.size / 1024 / 1024 > this._opt.size) {
							this.$message({
								message: this.$t('_t.upload.message.size', {size: this._opt.size})
							})
							this.$refs.file.value = '';
							return;
						}
					}
				}
				
				let list = [], data = [], count = files.length;
				!function loop(i) {
					if (i >= files.length) return;
					
					list.push({
						file: files[i],
						progress: rate => {
							data[i].rate = rate;
						},
						success: (path, obj) => {
							data[i].state = 1;
							data[i].path = path;
							data[i].obj = obj;
							
							if (--count == 0) {
								this._opt.loading && this.$loadOver();
							}
						},
						fail: msg => {
							data[i].state = 2;
							data[i].errorMessage = msg;
							
							if (--count == 0) {
								this._opt.loading && this.$loadOver();
							}
						}
					});
					
					data.push({
						name: files[i].name,
						size: parseFloat((files[i].size / 1024).toFixed(1)),
						state: 0,  // 上传状态（0：上传中；1：成功；2：失败）,
						rate: 0,
						path: '',
						obj: '',
						errorMessage: ''
					});
					loop.call(this, i + 1);
				}.call(this, 0);
				
				this._opt.loading && this.$loading();
				this._opt.listener && this._opt.listener(data);
				ossUpload(list, {
					success: data => {
						this.$refs.file.value = '';
						this._opt.loading && this.$loadOver();
						this._opt.success && this._opt.success(data);
					}
				});
			}
		}
	};
</script>
